<template>
  <ul class="navbar-nav ml-auto ml-md-0">
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-white" id="userDropdown" href="#" role="button" data-toggle="dropdown"
         aria-haspopup="true" aria-expanded="false">
        <span>{{ authUser.name }}</span>
        <font-awesome-icon icon="user-shield" class="ml-2" />
      </a>

      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
        <div v-if="authPos.id !== 5">
          <div class="dropdown-divider"></div>
          <router-link :to="{name:'ChangePassword'}" class="dropdown-item">
            Change password
          </router-link>
          <div class="dropdown-divider" ></div>
        </div>
        <a class="dropdown-item" @click="thisLogOut">
          Logout
        </a>
      </div>
    </li>
  </ul>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '../../../../mixins/app.mixins';
import {AlertService} from '../../../../service/alert.service';

export default {
  name: 'NavBarLeftMenu',

  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {

    };
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'logOut',
        ],
    ),
    async thisLogOut() {
      let confirmation = this.questionFormAlert('<span>Are you sure you want to log out</span>', 'Logout');
      if (await confirmation)
        this.logOut().then((r) => {
          if (r) {
            this.$router.push({name: 'Login'});
          }
        });
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'authUser',
          'authPos',
        ],
    ),
  },

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {

  },

};
</script>

<style scoped>
span {
  color: white !important;
}
</style>
